import { render, staticRenderFns } from "./DigitalSpecificIndicators.vue?vue&type=template&id=52247e42"
import script from "./DigitalSpecificIndicators.vue?vue&type=script&lang=ts"
export * from "./DigitalSpecificIndicators.vue?vue&type=script&lang=ts"
import style0 from "./DigitalSpecificIndicators.vue?vue&type=style&index=0&id=52247e42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports